module.exports = __webpack_public_path__ + "static/media/productos_ingredientes_mantequilla_cacahuate.59b15596.jpg";